import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CashAdvanceService } from '../../../services/cash-advance.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '../../../services/alert.service';
import { CashAdvance } from '../../../models/cashAdvances/cash.advance';
import { CustomValidators } from '../../../validators/customValidators';
import { Helper } from '../../../helpers/Helper';
import { DateHelper } from '../../../helpers/DateHelper';

@Component({
  selector: 'app-cash-advance-form',
  templateUrl: './cash-advance-form.component.html',
  styleUrls: ['./cash-advance-form.component.css']
})
export class CashAdvanceFormComponent implements OnInit {

  	form: FormGroup;
	cashAdvance: CashAdvance = new CashAdvance();
	loading: boolean = false;

	constructor(
		private _cashAdvanceService: CashAdvanceService,
		private _activatedRoute: ActivatedRoute,
		private _router: Router,
		private _alertService: AlertService
	) { }

	ngOnInit() {
		let id = this._activatedRoute.snapshot.params['id'];
		this.cashAdvance = new CashAdvance();
		this.cashAdvance.id = id;


		if (id == 0) {
			this.cashAdvance.id = 0;
			this.cashAdvance.dateRecieved = DateHelper.getDateNowString();
			this.cashAdvance.releasedById = Helper.currentUserId();

			this.form = this.createForm(this.cashAdvance);
		}
		else {
			this.form = this.createForm(this.cashAdvance);
			this._cashAdvanceService.getCashAdvance(id).subscribe(
				result => {
					if (result == undefined) {
						this.cashAdvance.id = 0;
					}
					else {
						this.cashAdvance = result;
						this.form = this.createForm(this.cashAdvance)
					}
				}
			);
		}
	}

	private createForm(cashAdvance: CashAdvance): FormGroup {
		return new FormGroup({
			recieverId: new FormControl(cashAdvance.recieverId, [
				Validators.required
			]),
			amount: new FormControl(cashAdvance.amount, [
				Validators.required,
				CustomValidators.validateCurrency
			]),
			releasedById: new FormControl(cashAdvance.releasedById, [
				Validators.required
			]),
			dateRecieved: new FormControl(cashAdvance.dateRecieved, [
				Validators.required
			]),
			reason: new FormControl(cashAdvance.reason),
		});
	}

	onFormSubmit(formValue) {
		if(!this.form.valid){
			this._alertService.showError('Invalid form data.');
			return;
		}
		
		this.cashAdvance.recieverId = formValue.recieverId;
		this.cashAdvance.amount = formValue.amount;
		this.cashAdvance.releasedById = formValue.releasedById;
		this.cashAdvance.dateRecieved = formValue.dateRecieved;
		this.cashAdvance.reason = formValue.reason;

		this.loading = true;
		if (this.cashAdvance.id == undefined || this.cashAdvance.id == 0) {
			this.create();
		}
		else {
			this.update();
		}
	}

	private create() {
		this._cashAdvanceService.addCashAdvance(this.cashAdvance).subscribe(
			result => {
				if (result != undefined && result['object'] != undefined) {
					this.cashAdvance = result.object;
					this.createForm(this.cashAdvance);
					this._alertService.showSuccess('Cash Advance information has been filed.');
				}
				else {
					this._alertService.displayErrorResult(result.errorCollection);
				}
				this.loading = false;
			}
		);
	}

	private update() {
		this._cashAdvanceService.updateCashAdvance(this.cashAdvance).subscribe(
			result => {
				if (result != undefined && result['object'] != undefined) {
					this.cashAdvance = result.object;
					this.createForm(this.cashAdvance);
					this._alertService.showSuccess('Cash Advance information has been updated.');
				}
				else {
					this._alertService.displayErrorResult(result.errorCollection);
				}
				this.loading = false;
			}
		);
	}

	isControlInvalid(controlName: string) {
		let control = this.form.controls[controlName];
		return control.invalid && (control.dirty || control.touched);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/cashAdvances/cash-advance-form/cash-advance-form.component.ts